var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 459.579 459.579",
    style: {
      enableBackground: "new 0 0 459.579 459.579"
    },
    xmlSpace: "preserve",
    fill: "#8F8F8F",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.579,14.7H139.935c-16.569,0-30,13.431-30,30v80.993h30V44.7h289.644v183.393h-48.495v30h48.495 c16.568,0,30-13.431,30-30V44.7C459.579,28.132,446.148,14.7,429.579,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.644,155.693H30c-16.565,0-30,13.427-30,30v183.393c0,16.569,13.431,30,30,30h92.333l29.531,35.11 c11.99,14.255,33.945,14.234,45.917,0l29.531-35.11h92.333c9.32,0,17.647-4.25,23.149-10.917c0.306-0.37,0.603-0.748,0.891-1.133 c3.743-5.005,5.96-11.219,5.96-17.95V185.693C349.644,169.126,336.214,155.693,319.644,155.693z M319.644,369.086h-106.3 l-38.522,45.799L136.3,369.086H30V185.693h289.644V369.086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.011,257.792h189.621c8.284,0,15-6.716,15-15s-6.716-15-15-15H80.011c-8.284,0-15,6.716-15,15 S71.727,257.792,80.011,257.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.011,325.573h77.621c8.284,0,15-6.716,15-15s-6.716-15-15-15H80.011c-8.284,0-15,6.716-15,15 S71.727,325.573,80.011,325.573z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogs);
export default __webpack_public_path__ + "static/media/dialogs.efcdf93c8d77447da444b0279faa6bc1.svg";
export { ForwardRef as ReactComponent };